// extracted by mini-css-extract-plugin
export default {"homePage":"Banner_homePage__oTuiS","imgBanner":"Banner_imgBanner__wMP9L","divTexte":"Banner_divTexte__mO4ZX","texteBanner":"Banner_texteBanner__GF6s-"};